import * as React from "react";
import { forwardRef } from "react";
const SvgPanel = ({ title, titleId, ...props }, ref) => /* @__PURE__ */ React.createElement("svg", {
	viewBox: "0 0 24 24",
	fill: "none",
	xmlns: "http://www.w3.org/2000/svg",
	ref,
	"aria-labelledby": titleId,
	...props
}, title ? /* @__PURE__ */ React.createElement("title", { id: titleId }, title) : null, /* @__PURE__ */ React.createElement("path", {
	d: "M5.3999 13.5225V20H10.1999V15.2891C10.1999 14.6386 10.7372 14.1113 11.3999 14.1113H12.5999C13.2626 14.1113 13.7999 14.6386 13.7999 15.2891V20H18.5999V13.5225",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M3 12.3448L11.152 4.34484C11.6206 3.88507 12.3802 3.88507 12.8488 4.34484L21 12.3448",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}), /* @__PURE__ */ React.createElement("path", {
	d: "M15.6001 7.04499V5.86726H18.6001V9.98932",
	stroke: "currentColor",
	strokeWidth: 1.5,
	strokeLinecap: "round",
	strokeLinejoin: "round"
}));
const ForwardRef = forwardRef(SvgPanel);
export default ForwardRef;
